import * as React from 'react';
export var SidebarContext = React.createContext({
    expanded: true,
    onCollapseChange: function () { return void 0; },
    collapsed: false,
});
export var useSidebarContext = function () { return React.useContext(SidebarContext); };
